module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '标题名称',
      value: 'name',
    },
    {
      name: '操作',
      width: 100,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button',
          {
            props: {
              type: 'danger',
              size: 'mini',
              loading: row.delete_btn_loading,
            },
            on: {
              click: (event) => {
                event.stopPropagation();
                s.onDeleteComponent(row);
              },
            },
          },
          '删除'
        );
        return ele;
      },
    },
  ];
};
